import { useQuery } from '@tanstack/react-query';
import { getFederaciones } from '../../services/federacionesService';

/**
 * Hook para obtener todas las federaciones
 * @param {object} options - Opciones de React Query
 */
export const useFederaciones = (options = {}) => {
  return useQuery({
    queryKey: ['federaciones'],
    queryFn: () => getFederaciones(null),
    staleTime: 60 * 60 * 1000, // 1 hour — federaciones rarely change
    ...options,
  });
};

export default useFederaciones;
